import { SelectOption } from 'types/common/select';
import {
  ConnectCommunityUserType,
  ConnectEverywearStatus,
  ConnectInitObjectProps,
  ConnectUserStatus,
  ConnectUserSupplierType,
  ConnectUserType,
  UserStatus,
} from 'types/member';

export const connectStatusLabel = {
  [ConnectUserStatus.ACTIVE]: 'Active',
  [ConnectUserStatus.INACTIVE]: 'Inactive',
};

export const CONNECT_ABUSING_PAYMENT = 'payment';
export const CONNECT_ABUSING_COMMUNITY = 'community';

export const CONNECT_ABUSING_USER = [
  { label: 'Payment', value: CONNECT_ABUSING_PAYMENT },
  { label: 'Community', value: CONNECT_ABUSING_COMMUNITY },
];

export const connectStatusOption: SelectOption[] = [
  {
    label: connectStatusLabel[ConnectUserStatus.ACTIVE],
    value: ConnectUserStatus.ACTIVE,
  },
  {
    label: connectStatusLabel[ConnectUserStatus.INACTIVE],
    value: ConnectUserStatus.INACTIVE,
  },
];

export const connectEverywearStatusLabel = {
  [ConnectEverywearStatus.ACTIVE]: 'Active',
  [ConnectEverywearStatus.INACTIVE]: 'Inactive',
};

export const connectEverywearStatusOption: SelectOption<ConnectEverywearStatus>[] = [
  {
    label: connectEverywearStatusLabel[ConnectEverywearStatus.ACTIVE],
    value: ConnectEverywearStatus.ACTIVE,
  },
  {
    label: connectEverywearStatusLabel[ConnectEverywearStatus.INACTIVE],
    value: ConnectEverywearStatus.INACTIVE,
  },
];

export const userStatusOption: SelectOption<UserStatus>[] = [
  {
    label: 'Active',
    value: UserStatus.ACTIVE,
  },
  {
    label: 'Inactive',
    value: UserStatus.INACTIVE,
  },
];

export const connectUserTypeOption: SelectOption<ConnectUserType>[] = [
  {
    label: 'General',
    value: ConnectUserType.GENERAL,
  },
  {
    label: 'Official',
    value: ConnectUserType.OFFICIAL,
  },
  {
    label: 'Supplier',
    value: ConnectUserType.SUPPLIER,
  },
  {
    label: 'CLO Creator Collective',
    value: ConnectUserType.CLO_CREATOR_COLLECTIVE,
  },
];

export const MAX_COUPON_RATE = 20;
export const MAX_COUPON_AMOUNT = 1000;

export enum CouponStatus {
  CANCELED = -1,
  USED,
  ISSUED,
}

export const couponStatusLabel = {
  [CouponStatus.CANCELED]: 'Canceled',
  [CouponStatus.USED]: 'Used',
  [CouponStatus.ISSUED]: 'Issued',
};

export enum CouponType {
  RATE = 1,
  PRICE = 2,
}

export const couponTypeOption: SelectOption<CouponType>[] = [
  {
    label: 'Price',
    value: CouponType.PRICE,
  },
  {
    label: 'Rate',
    value: CouponType.RATE,
  },
];

export const couponTypeLabel = {
  [CouponType.PRICE]: 'Price',
  [CouponType.RATE]: 'Rate',
};

export enum CouponReason {
  EVENT,
  REFERRAL,
  SURVEY,
  OTHER_REWARD,
}

export const couponReasonOption: SelectOption<CouponReason>[] = [
  {
    label: 'Event',
    value: CouponReason.EVENT,
  },
  {
    label: 'Referral',
    value: CouponReason.REFERRAL,
  },
  {
    label: 'Survey',
    value: CouponReason.SURVEY,
  },
  {
    label: 'Other Reward',
    value: CouponReason.OTHER_REWARD,
  },
];

export const couponReasonLabel = {
  [CouponReason.EVENT]: 'Event',
  [CouponReason.REFERRAL]: 'Referral',
  [CouponReason.SURVEY]: 'Survey',
  [CouponReason.OTHER_REWARD]: 'Other Reward',
};

export const connectUserSupplierTypes = [
  {
    label: 'Fabric',
    value: ConnectUserSupplierType.Fabric,
  },
  {
    label: 'Trim',
    value: ConnectUserSupplierType.Trim,
  },
];

export const connectCommunityUserTypeOption: SelectOption<ConnectCommunityUserType>[] = [
  {
    label: 'General',
    value: ConnectCommunityUserType.GENERAL,
  },
  {
    label: 'CLOver',
    value: ConnectCommunityUserType.CLOVER,
    divider: 'bottom',
  },
];

export const INITIAL_MEMBER_FILTER_VALUES: ConnectInitObjectProps = {
  connectAbusingUserStatus: {
    [CONNECT_ABUSING_PAYMENT]: false,
    [CONNECT_ABUSING_COMMUNITY]: false,
  },
  everywearCreatorStatus: {
    [ConnectEverywearStatus.ACTIVE]: true,
    [ConnectEverywearStatus.INACTIVE]: true,
  },
  connectUserType: {
    [ConnectUserType.GENERAL]: true,
    [ConnectUserType.OFFICIAL]: true,
    [ConnectUserType.SUPPLIER]: true,
    [ConnectUserType.CLO_CREATOR_COLLECTIVE]: true,
  },
  connectCommunityUserType: {
    [ConnectCommunityUserType.CLOVER]: true,
    [ConnectCommunityUserType.GENERAL]: true,
  },
};
